<h1 mat-dialog-title>{{ "revoke_Revoke" | translate }}</h1>

<mat-dialog-content>
  <h3>{{ "revoke.Message" | translate }}</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="buttons">
    <button mat-flat-button mat-dialog-close>Close</button>
    <button
      mat-raised-button
      class="ms-2"
      color="primary"
      (click)="revokeCase()"
    >
      {{ "revoke_Revoke" | translate }}
    </button>
  </div>
</mat-dialog-actions>
